import { Gender, GenderLabel } from "@/constants";
import { Tag } from "antd";

export function GenderTag(props: Room) {
	const { gender } = props;

	return (
		<Tag
			style={{
				color: getGenderColor(gender),
				backgroundColor: getGenderColor(gender) + "20",
				borderColor: getGenderColor(gender),
				paddingBlock: 2,
				paddingInline: 12,
			}}
		>
			{GenderLabel[gender]}
		</Tag>
	);
}

function getGenderColor(type: Gender) {
	switch (type) {
		case Gender.MALE:
			return "#2b7fff";
		case Gender.FEMALE:
			return "#f0b100";
		case Gender.MONK:
			return "#fb2c36";
		case Gender.NUN:
			return "#f6339a";
		default:
			return "default";
	}
}
